module.exports = __webpack_public_path__ + "img/genicon-icons8-heart-filled-outline.89a96e95.svg";